/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Type of value     * `Percentage`    - german: Prozentsatz   * `Currency`      - german: Währung
 */
export const ValueType = {
  Percentage: 'Percentage',
  Currency: 'Currency',
} as const;
export type ValueType = (typeof ValueType)[keyof typeof ValueType];
